// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/dist/css/swiper.css';
import App from './App'
import router from './router'
import ViewUI from 'view-design';
// import 'view-design/dist/styles/iview.css';
import './my-theme/my-theme.less';
import "./my-theme/index.less";
// Vue.use(VueAwesomeSwiper)
//vuex配置文件
import store from './config/store';


// require styles
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)

import filter from './config/filter';

Vue.use(filter);


Vue.config.productionTip = false
Vue.use(ViewUI);
import ElementUI from 'element-ui';
// 原来elementUi的样式
// import 'element-ui/lib/theme-chalk/index.css';
import "./style/elelementUi/index.css"
import "./style/app.less"
Vue.use(ElementUI);

//后台传输加密
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt

// 前端加密解密
import CryptoJS from 'crypto-js';
Vue.prototype.$CryptoJS = CryptoJS

// 省市区
import area from '../static/utils/area';
Vue.prototype.Area = area;

// router.beforeEach((to, from, next) => {
//     if (to.path == '/news' || to.path == '/' || to.path == '/about' || to.path == '/job' || to.path == '/login' || to.path == '/newsDetail') {
//         if (Vue.prototype.getCookie('U_id')) {
//             next('/myCenter')
//         } else {
//             next()
//         }
//     } else {
//         if (Vue.prototype.getCookie('U_id')) {
//             next()
//         } else {
//             next('/login')
//         }
//     }
// })
router.beforeEach((to, from, next) => {
    if (to.path == '/editorFastOrder' || to.path == '/editorOrder' || to.path == '/myCenter' || to.path == '/orderManage' || to.path == '/orderDetail' || to.path == '/auntDetail' || to.path == '/addOrder' || to.path == '/orderContent') {
        if (Vue.prototype.getCookie('U_id')) {
            next()
        } else {
            next('/login')
        }
    } else if (to.path == '/login') {
        if (Vue.prototype.getCookie('U_id')) {
            next('/myCenter')
        } else {
            next()
        }
    } else {
        next()
    }
})
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


//上传图片
import Upload from '@/components/upload.vue';
Vue.component('zUpload', Upload);

import Modular from '@/components/common/zModular.vue';
Vue.component('zModular', Modular);



// WEBPACK FOOTER //
// ./src/main.js